module.exports = require("@swa-ui/dotcom/src/placements/SpecialOffersPlacement/SpecialOffersPlacement.module.scss");